import { useEffect, useState } from "react";
import { Button, Card, DatePicker, Form, Switch, message, Spin } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import { convertFileToBase64 } from "../../../utils/utilFunctions";

const PopupManager = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imageFileMobile, setImageFileMobile] = useState(null);
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    fetchPopup();
  }, []);

  const fetchPopup = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_URI}/v1/popups`);
      const first = res.data?.[0];
      setPopup(first || null);
      form.setFieldsValue({
        active: first?.active ?? true,
        expiresAt: first?.expiresAt ? dayjs(first.expiresAt) : null,
      });
    } catch (err) {
      console.error("Error cargando popup", err);
      message.error("No se pudo cargar el popup");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    setSaving(true);
    try {
      const payload = {
        active: values.active ?? true,
        expiresAt: values.expiresAt
          ? dayjs(values.expiresAt).endOf("day").toISOString()
          : undefined,
      };
      if (imageFile instanceof File) {
        payload.image = {
          file: await convertFileToBase64(imageFile),
          filename: imageFile.name,
        };
      }
      if (imageFileMobile instanceof File) {
        payload.imageMobile = {
          file: await convertFileToBase64(imageFileMobile),
          filename: imageFileMobile.name,
        };
      }
      await axios.post(`${process.env.REACT_APP_URI}/v1/popups`, payload);
      message.success("Popup guardado");
      setImageFile(null);
      setImageFileMobile(null);
      fetchPopup();
    } catch (err) {
      console.error("Error guardando popup", err);
      const apiMessage = err.response?.data?.message;
      message.error(apiMessage || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  };

  const handleDeactivate = async () => {
    if (!popup) return;
    setSaving(true);
    try {
      await axios.patch(`${process.env.REACT_APP_URI}/v1/popups/${popup.id}`, {
        active: false,
      });
      message.success("Popup desactivado");
      fetchPopup();
    } catch (err) {
      console.error("Error desactivando popup", err);
      message.error("No se pudo desactivar");
    } finally {
      setSaving(false);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    setImageFile(file || null);
  };

  return (
    <div className="p-4">
      <Card title="Popup dinámico (landing)">
        {loading ? (
          <div className="text-center py-4">
            <Spin />
          </div>
        ) : (
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Activo"
              name="active"
              valuePropName="checked"
              tooltip="Si está activo y vigente se mostrará en la landing"
            >
              <Switch defaultChecked />
            </Form.Item>

            <Form.Item
              label="Fecha de vencimiento"
              name="expiresAt"
              rules={[{ required: true, message: "Selecciona la fecha de vencimiento" }]}
              tooltip="Vigente hasta las 23:59 de ese día (hora España)"
            >
              <DatePicker className="w-100" format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item label="Imagen desktop (S3) — sugerido 1200x1200 (peso recomendado ≤1MB, no bloquea mayores)">
              <input type="file" accept="image/*" onChange={handleImageChange} />
              {popup?.imageUrl && !imageFile && (
                <div className="mt-2">
                  <a href={popup.imageUrl} target="_blank" rel="noreferrer">
                    Ver imagen desktop actual
                  </a>
                </div>
              )}
            </Form.Item>

            <Form.Item label="Imagen mobile (S3) — sugerido 800x1000 (peso recomendado ≤1MB, no bloquea mayores)" name="imageMobile">
              <input type="file" accept="image/*" onChange={(e) => setImageFileMobile(e.target.files?.[0] || null)} />
              {popup?.imageUrlMobile && (
                <div className="mt-2">
                  <a href={popup.imageUrlMobile} target="_blank" rel="noreferrer">
                    Ver imagen mobile actual
                  </a>
                </div>
              )}
            </Form.Item>

            <div className="d-flex gap-2">
              <Button type="primary" htmlType="submit" loading={saving}>
                Guardar popup
              </Button>
              <Button onClick={fetchPopup} disabled={saving}>
                Refrescar
              </Button>
              <Button danger onClick={handleDeactivate} disabled={saving || !popup}>
                Desactivar
              </Button>
            </div>
          </Form>
        )}
      </Card>
    </div>
  );
};

export default PopupManager;

